module.exports = __webpack_public_path__ + "img/post.bc370015.png";